(function ($, Cobalt, undefined) {
    Cobalt.AccountMerge = {
        initialize: function() {
            var $form = $("#account-merge-form");
            if ($form.length > 0) {

                Cobalt.AccountMerge.handleStepChange({ "nextStep": $form.find("#field-step").val() });

                $form.ajaxForm({
                    beforeSubmit: function () {
                        if ($form.find("#field-step").val().toString() === "3") {
                            $(".j-confirm-warning-message").show();
                        } else {
                            $(".j-confirm-warning-message").hide();
                        }
                        $form.mask();
                    },
                    success: function (data) {
                        $.info(data);
                        if (data && data.status == "success") {
                            $form.find(".error-message").text("");

                            if (data.returnUrl) {
                                document.location = data.returnUrl;
                            } else {
                                Cobalt.AccountMerge.handleStepChange(data);
                            }
                        } else {
                            if (data.errors) {
                                $.info(data.errors);
                               $form.find(".error-message").text(data.errors.join(", ")).css("color", "red");
                           }
                        }
                        $form.unmask();
                    },
                    error: function() {
                        $form.unmask();
                    }
                });
            }

        },
        handleStepChange: function (data) {
            $.info(data.nextStep);
            var $stepLogout = $(".account-merge-step-logout");
            var $step1 = $(".account-merge-step-1");
            var $step2 = $(".account-merge-step-2");
            var $step3 = $(".account-merge-step-3");
            var $stepComplete = $(".account-merge-step-complete");

            $("#field-step").val(data.nextStep);
            
            switch (data.nextStep.toString()) {
                case "logout":
                case "new":
                    {
                        $("#field-step").val("logout"); //explicit set

                        $stepLogout.fadeIn();
                        $step1.hide();
                        $step2.hide();
                        $step3.hide();
                        $stepComplete.hide();
                        break;
                    }
                case "1":
                    {
                        $stepLogout.fadeOut(function()
                        {
                            $step1.fadeIn();
                        });
                        $step2.hide();
                        $step3.hide();
                        $stepComplete.hide();
                        break;
                    }
                case "2":
                    {
                        $stepLogout.hide();
                        $step1.fadeOut(function () {
                            $(".curse-email").text(data.curseEmail);
                            $(".curse-username").text(data.curseUsername);
                            $("#field-curse-userid").val(data.curseUserID);
                            $step2.fadeIn();
                        });
                        $step3.hide();
                        $stepComplete.hide();
                        break;
                    }
                case "3":
                    {
                        $stepLogout.hide();
                        $step1.hide();
                        $step2.fadeOut(function () {
                            $(".site-email").text(data.siteUser.email);
                            $(".site-username").text(data.siteUser.username);
                            $(".site-posts").text(data.siteUser.postCount);
                            $(".site-private-messages").text(data.siteUser.pmCount);
                            $("#field-external-site-userid").val(data.siteUser.id);
                            $(".curse-email").text(data.curseUser.email);
                            $(".curse-username").text(data.curseUser.username);
                            $(".curse-posts").text(data.curseUser.postCount);
                            $(".curse-private-messages").text(data.curseUser.pmCount);
                            $(".curse-posts-add").text("(+"+ data.siteUser.postCount + ")");
                            $(".curse-private-messages-add").text("(+" + data.siteUser.pmCount + ")");
                            $step3.fadeIn();
                        });
                        $stepComplete.hide();
                        break;
                    }
                case "complete":
                    {
                        $stepLogout.hide();
                        $step1.hide();
                        $step2.hide();
                        $step3.fadeOut(function() {
                            $stepComplete.fadeIn();
                        });
                        break;
                    }

            }
            
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.AccountMerge.js